import {
  PROFILE_ORDER_HISTORY,
  REPORT_ALL_CANDIDATES,
  REPORT_ALL_REFERRALS,
  REPORT_BUSINESS_BUILDER_COACHES,
} from '/enum/records.enum';
import {DATE_ADDED, OPTIONS} from '/enum/sort.enum';

export const showReportsWithSortByLabel = [
  PROFILE_ORDER_HISTORY,
  REPORT_ALL_CANDIDATES,
  REPORT_BUSINESS_BUILDER_COACHES,
  REPORT_ALL_REFERRALS,
];

export const getSortByWithLabel = (recordsName: any) => {
  switch (recordsName) {
    case REPORT_ALL_CANDIDATES:
      return DATE_ADDED;

    default:
      return OPTIONS;
  }
};
